import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { HomeTwoComponent } from './pages/home-two/home-two.component';

export const routes: Routes = [
    {path: '', component: HomeComponent},
    {path: 'home-two', component: HomeTwoComponent}
];
